<template>
	<div class=" flex layout-row">
		<v-select class="font-picker" :options="fonts" label="family" :value="activeFont"
		          :clearable="clearable" :reduce="font => font.family" placeholder="Default font"
		          append-to-body @input="onChange">
			<template v-slot:option="font">
				<div class="layout-row" style="min-width: 200px">
					<span :class="`ql-font-${snakeCase(font.family)} `">
						{{ font.family }}
					</span>
					<div class="flex" style="min-width: 20px"></div>
					<span :class="`ql-font-${snakeCase(font.family)} `">
						SAMPLE
					</span>
				</div>
			</template>
		</v-select>
	</div>
</template>

<script>

export default {
	name:'FontPicker',
  props: ['activeFont', 'apiKey', 'options', 'clearable'],

  data() {
    return {
	    fontManager: null,
    };
  },

  computed: {
    fonts() {
	    return this.fontManager.fonts;
    },
	  currentFont() {

	  }
  },
  mounted() {
    // TODO: Get fonts used in the current doc.
    // if (localStorage.getItem('recently-used-fonts')) {
	  //   this.recentlyUsedFonts = JSON.parse(localStorage.getItem('recently-used-fonts'));
    // }
  },
  methods: {
    onChange(font) {
	    this.$emit('change', font)
    },
    snakeCase(text) {
	    return text.replace(/\s+/g, '-').toLowerCase();
    },
  },
  created() {
    this.fontManager = window.fontManager;
  }
}
</script>

<style lang="scss">
.font-picker {
	position: relative;
	width: 100%;

	.vs__selected {
		white-space: nowrap;
		text-overflow: ellipsis;
		width: 100%;
	}

	.vs__dropdown-toggle {
		border: 1px solid $grey;
		border-radius: 4px;
		height: 28px;
		overflow: hidden;
		min-height: 28px;

		&:hover {
			border-color: $blue;
		}
	}
}
</style>
